export default __webpack_public_path__ + "static/media/IntertekLogo.27d7c74d.svg";